import React from 'react'
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { Typography } from '@mui/material'
import './style.scss'
import CloseIcon from '@mui/icons-material/Close';


const SubStop = ({address, count, color, index, removeStop, stopNote}) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
            <span style={{ position: 'relative', display: 'inline-block' }}>
                <LocationOnIcon style={{ width: 20, height: 20, color: '#D32F2F' }} />
                <div style={{ fontSize: 8, width: 10, height: 10, borderRadius: 5, backgroundColor: color, color: '#fff', display: 'flex', justifyContent: 'center', alignItems: 'center', top: 0, right: -3, position: 'absolute' }}>{count}</div>
            </span>
            {removeStop && (
                <CloseIcon style={{ width: 16, height: 16, color: 'red', marginLeft: 5, cursor: 'pointer' }} onClick={() => removeStop(index)} />
            )}
        </div>
        <Typography fontSize={12} style={{ textAlign: 'center', marginTop: 4, wordBreak: "break-word", width: '100%', lineHeight: '1.2', color: '#333' }}>{address}</Typography>
    </div>
  )
}

export default SubStop    